/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {DownloadTemplate} from '@ion/core/src/types/templates';
import {
  CSVExportButton
} from '../buttons/CSVExportButton';
import {IconButtonLabelPlacement} from '../buttons/IconButton';
import {
  RefreshGridButton
} from '../buttons/RefreshGridButton';
import {GridControlsBank} from './GridControlsBank';

export interface GridActionProps {
  onExport?: (params?: DownloadTemplate) => void;
  isExporting?: boolean;
  tooltipTitle?: string;
  onRefresh?: (params?: boolean) => void;
}

const useStyles = makeStyles(() => ({
  gridActionsContainer : {
    display        : 'flex',
    justifyContent : 'end'
  }
}));

/**
 * Displays available grid actions (such as refresh or export) above a grid as a row of icons.
 */
export const GridActions = ({
  onExport,
  onRefresh,
  tooltipTitle,
  isExporting = false
}: GridActionProps) => {
  const classes = useStyles();
  return (
    <GridControlsBank controlsClassName={classes.gridActionsContainer}>
      {onRefresh && (
        <RefreshGridButton onRefresh={onRefresh}
          currentLabelPlacement={IconButtonLabelPlacement.HORIZONTAL} />
      )}
      {onExport && <CSVExportButton onExport={onExport}
        entity={tooltipTitle}
        isIncludeTitle={!!tooltipTitle}
        isExporting={isExporting}
        currentLabelPlacement={IconButtonLabelPlacement.HORIZONTAL} />}
    </GridControlsBank>
  );
};

export default GridActions;
